import { createRoot } from "react-dom/client";
import "@fontsource/roboto";
import "./index.css";
import App from "./App.tsx";
import { Toaster } from "./components/ui/sonner";

createRoot(document.getElementById("root")!).render(
  // <StrictMode>
  <>
    <App />
    <Toaster duration={6000} />
  </>

  // </StrictMode>
);
